import React from 'react';
import { state } from 'State';
import withProps from 'recompose/withProps';
import compose from 'recompose/compose';

const tryingToClose =
  (search_open, secondary_search_division, clicked_on) =>
    search_open === "secondary" && secondary_search_division === clicked_on

const addCallbacks = withProps({
  toggleLgaSearch: () =>
    tryingToClose(state.get('ui', 'search_open'),
                  state.get('ui', 'secondary_search_division'), 'lga')
      ? state.select("ui").merge({
        search_open: "",
        secondary_search_division: ""
      })
      : state.select("ui").merge({
        search_open: "secondary",
        secondary_search_division: "lga"
      }),
  toggleSedSearch: () =>
    tryingToClose(state.get('ui', 'search_open'),
                  state.get('ui', 'secondary_search_division'), 'sed')
      ? state.select("ui").merge({
        search_open: "",
        secondary_search_division: ""
      })
      : state.select("ui").merge({
        search_open: "secondary",
        secondary_search_division: "sed"
      })
});

const borderFor = (tree, label) => tree.ui.search_open == "secondary" &&
                        tree.ui.secondary_search_division == label ?
                        "border-bottom-0" : "";

const SecondarySearchBar = ({tree, hidden, toggleLgaSearch, toggleSedSearch}) => (
  <div hidden={hidden} id="secondary-search" className="black">

    <div style={{width: 165}} className="pr-0">
      Refine
    </div>

    <div style={{flexGrow: 0.5}}
    id="lga-dropdown" onClick={toggleLgaSearch} className={`${borderFor(tree, "lga")}`}>
      {
        tree.domain_data.geo_aggregation == "lga" && tree.domain_data.geo_aggregation_value ?
        tree.domain_data.geo_aggregation_value + " (LGA)": "Local Government Area"
      }
      <i className="fa fa-caret-down"/>
    </div>

    <div style={{flexGrow: 0.5}} id="sed-dropdown" onClick={toggleSedSearch} className={`${borderFor(tree, "sed")}`}>
      {
        tree.domain_data.geo_aggregation == "sed" && tree.domain_data.geo_aggregation_value ?
        tree.domain_data.geo_aggregation_value + " (ED)" : "Electoral Division"
      }
      <i className="fa fa-caret-down"/>
    </div>
    {/* this exists just for css reasons (border of child elements) */}
    {/* <div className="col border-right-0 "></div> */}
  </div>
);

export default addCallbacks(
  SecondarySearchBar
);



// WEBPACK FOOTER //
// ./components/SecondarySearchBar.js